export default "__VITE_ASSET__db35ad82__"